import { createSvgiconString } from "../../svgicons/front.js";

/**
 * Accès au dom du slider
 */
const dom = {
    player: $slider => $slider.querySelector(".PLAYER"),
    player_container: $slider => $slider.querySelector(".PLAYER .CONTAINER"),
    player_imgdyns: $slider => [...dom.player_container($slider).children],
    player_imgs: $slider => [...$slider.querySelectorAll(".PLAYER img")],

    thumbnails: $slider => $slider.querySelector(".THUMBNAILS"),
    thumbnails_container: $slider => $slider.querySelector(".THUMBNAILS .CONTAINER"),
    thumbnails_imgdyns: $slider => [...dom.thumbnails_container($slider).children],
    thumbnails_imgs: $slider => [...$slider.querySelectorAll(".THUMBNAILS img")],

    btns: $slider => [...$slider.querySelectorAll("button")]
};

/**
 *
 */
export class SliderThumbnails {
    //-------------------------------------------------- STATIC -----------------------------------------------------------

    static createElement(id, contentString){
        const $slider = document.createElement("div");
        $slider.id = id;
        $slider.className = "slider SliderThumbnails";
        $slider.dataset.slidertype = "SliderThumbnails";
        const $prev = createSvgiconString("prev");
        const $next = createSvgiconString("next");

        $slider.innerHTML = `            
            <div class="PLAYER">
                <div class="CONTAINER">
                    ${contentString}
                </div>
            </div>
            <div class="THUMBNAILS">
                <div class="CONTAINER">
                    <div class="img empty"></div>
                    <div class="img empty"></div>
                    <div class="img empty"></div>
                    <div class="img empty"></div>
                </div>
            </div>
            <button class="slider-btn slider-btn-prev" data-direction="prev">
                ${$prev}
            </button>
            <button class="slider-btn slider-btn-next" data-direction="next">
                ${$next}
            </button>          
        `;

        return $slider;
    }  
    
    //------------------------------------------------- INSTANCE ------------------------------------------------------------

    element = null;
    current = 0;
    nb = 0;
    /**
     * @param {Element} $element
     */
    constructor($element) {
        this.element = $element;
        // imgs
        const player_container     = this.getDom("player_container");
        const player_imgdyns       = this.getDom("player_imgdyns");
        const thumbnails_container = this.getDom("thumbnails_container");
        this.nb  = player_imgdyns.length;

        player_container.style.width     = 100 * this.nb + "%";
        thumbnails_container.style.width = 25 * this.nb + "%";
        thumbnails_container.innerHTML   = "";

        player_imgdyns.forEach(($player_imgdyn, i) => {
            $player_imgdyn.style.width = `${100 / this.nb}%`;
            // ajout thumbnail
            const $thumbnail_imgdyn = $player_imgdyn.cloneNode(true);
            $thumbnail_imgdyn.classList.remove("container-slide");
            $thumbnail_imgdyn.classList.add("thumbnail-slide");
            $thumbnail_imgdyn.style.width = `${100 / this.nb}%`;
            thumbnails_container.appendChild($thumbnail_imgdyn);
        });

        // btns
        const $btns = this.getDom("btns");
        $btns.forEach($btn => $btn.addEventListener("click",this.onClickBtn));

        // Select 1ere image par défaut
        this.select();
    }
    onClickBtn = e => {
        const $btn = e.currentTarget;
        const direction = $btn.dataset.direction;
        if (typeof this[direction] === "function") {
            this[direction]();
            this.positionPlayer();
            this.positionThumbnails();
            this.select();
        }        
    }
    prev() {
        this.current--;
        if (this.current < 0) this.current = this.nb - 1;
    }
    next() {
        this.current++;
        if (this.current > this.nb - 1) this.current = 0;
    }
    position(index=0){
        if(index < 0 || index > this.nb - 1)
            index = 0;
        this.current = index;
        this.positionPlayer();
        this.positionThumbnails();
        this.select();
    }

    positionPlayer() {
        const offset = (100 / this.nb) * this.current * -1;
        this.getDom("player_container").style.transform = `translateX(${offset}%)`;
    }
    positionThumbnails() {
        if (this.current > 3) {
            const offset = (100 / this.nb) * (this.current - 3) * -1;
            this.getDom("thumbnails_container").style.transform = `translateX(${offset}%)`;
        } else if (this.current === 0) {
            this.getDom("thumbnails_container").style.transform = `translateX(0%)`;
        }
    }
    select() {
        this.getDom("thumbnails_imgdyns").forEach(($imgdyn, index) => {
            if (index !== this.current) {
                $imgdyn.classList.remove("selected");
            } else {
                $imgdyn.classList.add("selected");
            }
        });
    }
    destroy(){
        this.element.remove();
        this.element = null;
    }

    // --------------------------- Accès DOM -------------------------------------

    /**
     * Renvoi le dom de funcname
     * @param {string} funcname :
     * @returns {Element|Element[]|FALSE}
     */
    getDom(funcname) {
        return dom[funcname](this.element);
    }
}